export enum TEvent {
    CALL_DRIVER = 'CALL_DRIVER',
    COPY_LINK = 'COPY_LINK',
    COPY_DRIVER_NAME = 'COPY_DRIVER_NAME',
    COPY_BOOKING_ID = 'COPY_BOOKING_ID',
    CLICK_DRIVER_NAME = 'CLICK_DRIVER_NAME',
    CLICK_BOOKING_ID = 'CLICK_BOOKING_ID',
    DETAIL_BOOKING = 'DETAIL_BOOKING',
    RELOAD_MAP = 'RELOAD_MAP',
    CHAT_SUPPORT = 'CHAT_SUPPORT',
    WHATSAPP_DRIVER = 'WHATSAPP_DRIVER',
    RELOAD_PAGE = 'RELOAD_PAGE',
    EXTERNAL_TRACKING = 'EXTERNAL_TRACKING',
    TIME_IN_SMR = 'TIME_IN_SMR',
    OPEN_TRACKING = 'OPEN_TRACKING',
    CLOSE_TRACKING = 'CLOSE_TRACKING',
}

export const UNFULFILLMENT_EVENTS = {
    NOTIFICATIONS_OFF: 'NOTIFICATIONS_OFF',
    UNDELIVERED_MESSAGE: 'UNDELIVERED_MESSAGE',
    INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
    UNREAD_MESSAGE: 'UNREAD_MESSAGE',
    INSUFFICIENT_DELIVERY_INFORMATION: 'INSUFFICIENT_DELIVERY_INFORMATION',
    NOTIFICATIONS_OFF_WHATSAPP: 'NOTIFICATIONS_OFF_WHATSAPP',
    NOT_DRIVER_MOVEMENT: 'NOT_DRIVER_MOVEMENT',
    LIBERATION_BY_WAITING_TIME: 'LIBERATION_BY_WAITING_TIME',
    NO_BIG_COURIERS: 'NO_BIG_COURIERS',
    NO_BIG_COURIERS_ASSIGN: 'NO_BIG_COURIERS_ASSIGN',
    ISSUE_POINT_A: 'ISSUE_POINT_A',
    BAD_WEATHER_BUSINESS: 'BAD_WEATHER_BUSINESS',
    BAD_WEATHER_BUSINESS_LIGHT: 'BAD_WEATHER_BUSINESS_LIGHT',
    BAD_WEATHER_BUSINESS_HEAVY: 'BAD_WEATHER_BUSINESS_HEAVY',
    BAD_TRAFFIC_BUSINESS: 'BAD_TRAFFIC_BUSINESS',
    ADDRESS_NOT_MATCH: 'ADDRESS_NOT_MATCH',
    SINGLE_PROVIDER: 'SINGLE_PROVIDER',
    BUSINESS_IN_MALL: 'BUSINESS_IN_MALL',
    LONG_DISTANCE: 'LONG_DISTANCE',
    SHORT_DISTANCE: 'SHORT_DISTANCE',
    ON_BATCH: 'ON_BATCH',
    URBANIZATION_DELIVERY_POINT: 'URBANIZATION_DELIVERY_POINT',
    BAD_TRAFFIC_DELIVERY_POINT: 'BAD_TRAFFIC_DELIVERY_POINT',
    DANGER_ZONE: 'DANGER_ZONE',
    DRIVER_LOCATION_BY_LIBERATION: 'DRIVER_LOCATION_BY_LIBERATION',
    ORDER_BATCH_ACCEPTED: 'ORDER_BATCH_ACCEPTED',

};
